import { EMediaQuery } from '@NGUtils/enums';
import { addTransition, mq } from '@NGUtils/functions';
import Flex from '@layouts/Flex';
import styled, { css } from 'styled-components';

export const FlexEx = styled(Flex)<{ isVisible?: boolean }>`
	${(p) => css`
		position: absolute;
		bottom: 0;
		left: 0;

		width: auto;
		height: auto;

		border-radius: 5px;

		${addTransition()}

		backdrop-filter: blur(8px);
		background-color: #88ee8e10;

		& .content-label {
			// add text shadow
			text-shadow: 0 0 5px ${p.theme.colors.black + '50'};
		}

		${p.isVisible ? `opacity: 1; z-index: 2;` : `opacity: 0; z-index: 1;`}

		${mq(
			EMediaQuery.md,
			css`
				width: 90%;
				backdrop-filter: blur(2px);
				background-color: #00000090;

				border-top-left-radius: 0px;
				border-bottom-left-radius: 0px;

				& .content-label {
					// add text shadow
					//text-shadow: 0 0 5px #ffffff50;
					text-shadow: none;
				}
			`
		)}
	`}
`;
